export default {
  searchHistories: [],
  totalSearchHistories: 0
}
